export const BRIDGE_CONFIG: Record<string, { name: string; url?: string }> = {
  LIFI: {
    name: 'LIFI',
  },
  SYN: {
    name: 'SYNAPSE BRIDGE',
    url: 'https://synapseprotocol.com/',
  },
  ARB: {
    name: 'ARBITRUM BRIDGE',
    url: 'https://bridge.arbitrum.io/',
  },
  ACROSS: {
    name: 'ACROSS BRIDGE',
    url: 'https://across.to/bridge',
  },
  SQUID: {
    name: 'SQUID ROUTER',
    url: 'https://app.squidrouter.com',
  },
};
